import DashboardView from "../DashboardView.vue";
import DashboardPage from "../Pages/DashboardPage.vue";

const routes = [
  {
    path: '/admin',
    component: DashboardView,
    children: [
      {
        path: '',
        name: 'admin-dashboard',
        component: DashboardPage,
      },
    ]
  }
]

export default routes
